<template>
  <div class="p-sm-2">
    <div class="mt-2 mt-sm-3 position-relative">
      <b-row>
        <b-col cols="12">
          <upload-file-single
            v-on:file-uploaded="(file) => onFileUploaded(file, 'id_card_image', '⾝份証明⽂件')"
            file_delete_url="/user_documents"
            innerID="1"
            ref="childRef1"
            :props_previewImage="workerData.id_card_image"
            title="⾝份証明⽂件"
            :is_required="false"
          ></upload-file-single>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
        <b-col cols="12">
          <upload-file-single
            v-on:file-uploaded="(file) => onFileUploaded(file, 'registration_certificate_image_front', '工人註冊証正面')"
            file_delete_url="/user_documents"
            innerID="2"
            ref="childRef2"
            :props_previewImage="workerData.registration_certificate_image_front"
            title="工人註冊証正面"
            :is_required="false"
          ></upload-file-single>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
        <b-col cols="12">
          <upload-file-single
           v-on:file-uploaded="(file) => onFileUploaded(file, 'registration_certificate_image_back', '工人註冊証背面')"
            file_delete_url="/user_documents"
            innerID="3"
            ref="childRef3"
            :props_previewImage="workerData.registration_certificate_image_back"
            title="工人註冊証背面"
            :is_required="false"
          ></upload-file-single>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
        <b-col cols="12">
          <upload-file-single
           v-on:file-uploaded="(file) => onFileUploaded(file, 'safety_training_certificate_image', '建造業安全訓練證明書')"
            file_delete_url="/user_documents"
            innerID="4"
            ref="childRef4"
            :props_previewImage="workerData.safety_training_certificate_image"
            title="建造業安全訓練證明書"
            :is_required="false"
          ></upload-file-single>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
  
  <script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, computed } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import uploadFileSingle from "@/layouts/components/file/uploadFileSingle.vue";

export default {
  data() {
    return {
      required,
      idError: null,
      dragAndDropCapable: false,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    uploadFileSingle,
  },
  methods: {
    hide() {
      this.$router.replace("/workers/list");
    },
    onFileUploaded(file, key, title) {
      console.log('key 25/10', key);
      console.log('title 25/10', title);
      const renamedFile = new File([file], title, { type: file.type });
      this.workerData[key] = renamedFile; // Update the documents with the renamed file
      console.log(key, this.workerData[key]);
    },
    deleteWorkerDocument(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          store
            .dispatch("worker/deleteWorkerDocument", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    workerData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const props_previewImage = ref([]);
    watch(
      () => props.workerData,
      (newVal) => {
        if (newVal.documents) {
          props_previewImage.value = [...newVal.documents];
        }
      }
    );
    const resetWorkData = () => {
      workerData.value = JSON.parse(
        JSON.stringify({
          id: 0,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      props_previewImage,
    };
  },
};
</script>
  
  <style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
  
  <style lang="scss" scoped>
</style>
  